export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_05.f557f263.jpg";